import { render, staticRenderFns } from "./OrderVanCollapseContent.vue?vue&type=template&id=6b44948e&scoped=true"
import script from "./OrderVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./OrderVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./OrderVanCollapseContent.vue?vue&type=style&index=0&id=6b44948e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44948e",
  null
  
)

export default component.exports